export default __webpack_public_path__ + "static/media/js.531fb524.svg";